import type {
  TrackingEvent,
  TrackingPayload,
  BlogTagTrackingPayload,
  BlogArticleTrackingPayload,
  BlogThemenweltTrackingPayload,
} from '../types'

const useBlogEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => ({
  trackBlogTag: (blogTracking: BlogTagTrackingPayload) =>
    track('blog_tag_click', blogTracking),
  trackBlogArticle: (blogTracking: BlogArticleTrackingPayload) =>
    track('blog_article_click', blogTracking),
  trackBlogTopic: (blogTracking: BlogThemenweltTrackingPayload) =>
    track('blog_themenwelt_click', blogTracking),
})

export default useBlogEvents
